import { render } from "./CrewEdit.vue?vue&type=template&id=061f0fef"
import script from "./CrewEdit.vue?vue&type=script&lang=js"
export * from "./CrewEdit.vue?vue&type=script&lang=js"
script.render = render

export default script